import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";

// Fix default icon paths (Leaflet CSS loaded in index.html)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const userIcon = L.divIcon({
  className: "yh-user-marker",
  iconSize: [22, 22],
  iconAnchor: [11, 11],
  html: '<div style="width:16px;height:16px;border-radius:999px;background:#2563eb;border:3px solid white;box-shadow:0 0 0 3px rgba(37,99,235,0.35);"></div>',
});

const rescuerIcon = L.divIcon({
  className: "yh-vehicle-marker",
  iconSize: [30, 30],
  iconAnchor: [15, 15],
  html: '<div style="width:26px;height:26px;border-radius:8px;background:#FFC107;border:2px solid #111;display:grid;place-items:center;font-size:14px;font-weight:800;color:#111;">🛻</div>',
});

function Recenter({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.setView(center, zoom || map.getZoom());
  }, [center, zoom, map]);
  return null;
}

export default function MapView({
  center = [38.4823, 28.1391],
  zoom = 13,
  markers = [],
  userLocation = null,
  className = "",
}) {
  return (
    <div className={className} style={{ minHeight: 240 }}>
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Recenter center={center} zoom={zoom} />
        {userLocation && (
          <Marker position={userLocation} icon={userIcon}>
            <Popup>Buradasın</Popup>
          </Marker>
        )}
        {markers.map((m, i) => (
          <Marker key={m.id || i} position={[m.latitude, m.longitude]} icon={m.isVehicle ? rescuerIcon : new L.Icon.Default()}>
            {m.label && <Popup>{m.label}</Popup>}
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
